<template>
  <div class="pulse-strength-effect">
    <el-select
      v-close-on-zoom
      :value="state.location"
      placeholder="Any location"
      class="pulse-location-select"
      :disabled="readonly"
      @input="(location) => setLocation(location)"
    >
      <el-option
        v-for="location in pulseLocations"
        :key="location.key"
        :label="location.label.en"
        :value="location.key"
      />
      <el-option label="Central" value="ANY_CENTRAL" />
      <el-option label="Peripheral" value="ANY_PERIPHERAL" />
    </el-select>
    <span>&nbsp;to&nbsp;</span>
    <el-select
      class="pulse-strength-select"
      :value="state.strength"
      :disabled="readonly"
      @input="(strength) => setStrength(strength)"
    >
      <el-option
        v-for="strengthValue in strengthValues"
        :key="strengthValue"
        :label="strengthValue"
        :value="strengthValue"
      />
    </el-select>
  </div>
</template>

<script>
import get from 'lodash/get';
import range from 'lodash/range';

import pulseLocations from '~lib/common/config/pulseLocations';

export default {
  name: 'pulse-strength-effect',
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control'],
  data() {
    return {
      state: {
        location: pulseLocations[0].key,
        strength: 5,
      },
      pulseLocations,
      strengthValues: range(6),
    };
  },
  mounted() {
    const data = this.getData(this.ikey);
    this.state.location = get(data, 'id') || pulseLocations[0].key;
    this.state.strength = data && data.strength !== undefined ? data.strength : 5;
    this.update();
  },
  methods: {
    setLocation(location) {
      this.state.location = location;
      this.update();
    },
    setStrength(strength) {
      this.state.strength = strength;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'PALPABLE_PULSE',
        id: this.state.location,
        strength: this.state.strength,
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style scoped>
.pulse-strength-effect {
  display: flex;
  align-items: center;
}
</style>